import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "../Button";
import { Modal } from "../Modal";
import { DatesFormatter, DatesFormatterRange } from "../../utils/functions/datesFormatter";
import "./date-picker-mobile.scss";
const DatePickerMobileModal = ({ isOpen, title, subTitle, value, placeholder, confirmLabel = "Confirm", resetLabel = "Reset", dateCountSelected, localeLang, formatDateOptions, onDateClick, children, onReset, onClose, onConfirm, }) => {
    const getDateSelected = () => {
        return Array.isArray(value) ? [value === null || value === void 0 ? void 0 : value[0], value === null || value === void 0 ? void 0 : value[1]] : value !== null && value !== void 0 ? value : false;
    };
    const dateSelected = getDateSelected();
    const handleOnReset = () => {
        if (onReset) {
            onReset();
        }
    };
    const handleOnClose = () => {
        if (onClose) {
            onClose();
        }
    };
    const handleOnConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
    };
    const getDateFormatted = () => {
        if (dateSelected) {
            if (Array.isArray(dateSelected)) {
                if (dateSelected[0] && dateSelected[1]) {
                    return DatesFormatterRange(dateSelected[0], dateSelected[1], formatDateOptions, localeLang);
                }
                return placeholder;
            }
            return DatesFormatter(dateSelected, formatDateOptions, localeLang);
        }
        return placeholder;
    };
    const getDisabledState = () => {
        if (Array.isArray(dateSelected)) {
            if (dateCountSelected && dateCountSelected < 2) {
                return true;
            }
            return !!(!dateSelected[0] || !dateSelected[1]);
        }
        return !dateSelected;
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { className: "date-picker-mobile-button", color: "inverse", outlined: true, onClick: onDateClick, children: getDateFormatted() }), _jsxs(Modal, { className: "date-picker-mobile-modal", isOpen: isOpen, onClose: handleOnClose, children: [_jsx(Modal.Header, { className: "date-picker-mobile-modal__header", closeIcon: true, title: title, subtitle: subTitle, onClose: handleOnClose }), _jsx(Modal.Content, { className: "date-picker-mobile-modal__content", children: children }), _jsxs(Modal.Footer, { className: "date-picker-mobile-modal__footer", children: [_jsx(Button, { disabled: getDisabledState(), onClick: handleOnConfirm, fluid: true, rounded: true, children: confirmLabel }), _jsx(Button, { disabled: getDisabledState(), onClick: handleOnReset, fluid: true, color: "inverse", rounded: true, children: resetLabel })] })] })] }));
};
export default DatePickerMobileModal;
